module.exports = __webpack_public_path__ + "img/cart_leading-brands.a3371385.jpg";